import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function FullWidthIcon({
  className,
  style,
  color = "#5E678C",
  ...props
}: IconProps & { color?: React.CSSProperties["color"] }) {
  return (
    <svg
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M22 12H2M22 12L18 16M22 12L18 8M2 12L6 16M2 12L6 8'
        stroke={color}
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
